"use client";

import { c as _c } from "react/compiler-runtime";
import { AuthContext } from "@/components/auth/Auth";
import { ReactQueryWrapperContext } from "@/components/react-query-wrapper/ReactQueryWrapper";
import { ApiUpdateWaveRequest } from "@/generated/models/ApiUpdateWaveRequest";
import { ApiWave } from "@/generated/models/ApiWave";
import { convertWaveToUpdateWave } from "@/helpers/waves/waves.helpers";
import { commonApiPost } from "@/services/api/common-api";
import { useMutation } from "@tanstack/react-query";
import { useContext, useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import { useClickAway, useKeyPressEvent } from "react-use";
import WaveHeaderNameEditInput from "./WaveHeaderNameEditInput";
export default function WaveHeaderNameEditModal(t0) {
  const $ = _c(47);
  const {
    wave,
    onClose
  } = t0;
  const modalRef = useRef(null);
  useClickAway(modalRef, onClose);
  useKeyPressEvent("Escape", onClose);
  const {
    setToast,
    requestAuth
  } = useContext(AuthContext);
  const {
    onWaveCreated
  } = useContext(ReactQueryWrapperContext);
  const [mutating, setMutating] = useState(false);
  const [name, setName] = useState(wave.name);
  let t1;
  if ($[0] !== mutating || $[1] !== name || $[2] !== wave.name) {
    t1 = () => mutating || wave.name === name;
    $[0] = mutating;
    $[1] = name;
    $[2] = wave.name;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const getIsDisabled = t1;
  let t2;
  if ($[4] !== getIsDisabled) {
    t2 = getIsDisabled();
    $[4] = getIsDisabled;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const [isDisabled, setIsDisabled] = useState(t2);
  let t3;
  if ($[6] !== getIsDisabled) {
    t3 = () => setIsDisabled(getIsDisabled());
    $[6] = getIsDisabled;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== mutating || $[9] !== name || $[10] !== wave) {
    t4 = [wave, mutating, name];
    $[8] = mutating;
    $[9] = name;
    $[10] = wave;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  useEffect(t3, t4);
  let t5;
  if ($[12] !== wave.id) {
    t5 = async body => await commonApiPost({
      endpoint: `waves/${wave.id}`,
      body
    });
    $[12] = wave.id;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== onClose || $[15] !== onWaveCreated) {
    t6 = () => {
      onWaveCreated();
      onClose();
    };
    $[14] = onClose;
    $[15] = onWaveCreated;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== setToast) {
    t7 = error => {
      setToast({
        message: error as unknown as string,
        type: "error"
      });
    };
    $[17] = setToast;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = () => {
      setMutating(false);
    };
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== t5 || $[21] !== t6 || $[22] !== t7) {
    t9 = {
      mutationFn: t5,
      onSuccess: t6,
      onError: t7,
      onSettled: t8
    };
    $[20] = t5;
    $[21] = t6;
    $[22] = t7;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  const editNameMutation = useMutation(t9);
  let t10;
  if ($[24] !== editNameMutation || $[25] !== name || $[26] !== requestAuth || $[27] !== setToast || $[28] !== wave) {
    t10 = async e => {
      e.preventDefault();
      setMutating(true);
      const {
        success
      } = await requestAuth();
      if (!success) {
        setToast({
          type: "error",
          message: "Failed to authenticate"
        });
        setMutating(false);
        return;
      }
      const originalBody = convertWaveToUpdateWave(wave);
      const body_0 = {
        ...originalBody,
        name
      };
      await editNameMutation.mutateAsync(body_0);
    };
    $[24] = editNameMutation;
    $[25] = name;
    $[26] = requestAuth;
    $[27] = setToast;
    $[28] = wave;
    $[29] = t10;
  } else {
    t10 = $[29];
  }
  const onSubmit = t10;
  let t11;
  if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <div className="tw-fixed tw-inset-0 tw-bg-gray-600 tw-bg-opacity-50" />;
    $[30] = t11;
  } else {
    t11 = $[30];
  }
  let t12;
  if ($[31] !== name || $[32] !== wave) {
    t12 = <WaveHeaderNameEditInput wave={wave} name={name} setName={setName} />;
    $[31] = name;
    $[32] = wave;
    $[33] = t12;
  } else {
    t12 = $[33];
  }
  const t13 = `tw-w-full sm:tw-w-auto tw-flex tw-items-center tw-justify-center tw-relative tw-px-4 tw-py-3 tw-text-sm tw-font-semibold tw-border tw-border-solid tw-rounded-lg tw-transition tw-duration-300 tw-ease-out ${isDisabled ? "tw-cursor-not-allowed tw-text-iron-500 tw-bg-iron-800 tw-border-iron-800" : "tw-cursor-pointer tw-text-white tw-bg-primary-500 tw-border-primary-500 hover:tw-bg-primary-600 hover:tw-border-primary-600"}`;
  const t14 = mutating ? "hidden" : "visible";
  let t15;
  if ($[34] !== t14) {
    t15 = <div style={{
      visibility: t14
    }}>Save</div>;
    $[34] = t14;
    $[35] = t15;
  } else {
    t15 = $[35];
  }
  let t16;
  if ($[36] !== mutating) {
    t16 = mutating && <svg aria-hidden="true" role="output" className="tw-inline tw-w-5 tw-h-5 tw-text-primary-400 tw-animate-spin tw-absolute" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg"><path className="tw-text-iron-600" d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" /><path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentColor" /></svg>;
    $[36] = mutating;
    $[37] = t16;
  } else {
    t16 = $[37];
  }
  let t17;
  if ($[38] !== isDisabled || $[39] !== t13 || $[40] !== t15 || $[41] !== t16) {
    t17 = <div className="tw-flex tw-justify-end tw-mt-4"><button disabled={isDisabled} type="submit" className={t13}>{t15}{t16}</button></div>;
    $[38] = isDisabled;
    $[39] = t13;
    $[40] = t15;
    $[41] = t16;
    $[42] = t17;
  } else {
    t17 = $[42];
  }
  let t18;
  if ($[43] !== onSubmit || $[44] !== t12 || $[45] !== t17) {
    t18 = createPortal(<div className="tw-relative tw-z-50">{t11}<div className="tw-fixed tw-inset-0 tw-z-10 tw-overflow-y-auto"><div className="tw-flex tw-min-h-full tw-items-end tw-justify-center tw-text-center sm:tw-items-center tw-p-2 lg:tw-p-0"><div ref={modalRef} className="tw-max-w-full md:tw-max-w-xl tw-relative tw-w-full tw-transform tw-rounded-xl tw-bg-iron-950 tw-text-left tw-shadow-xl tw-transition-all tw-duration-500 sm:tw-w-full tw-p-6 lg:tw-p-8"><form onSubmit={onSubmit} className="tw-flex tw-flex-col">{t12}{t17}</form></div></div></div></div>, document.body);
    $[43] = onSubmit;
    $[44] = t12;
    $[45] = t17;
    $[46] = t18;
  } else {
    t18 = $[46];
  }
  return t18;
}